import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../components/Navbar";
import SeccionBancos from "../components/Bancos/SeccionBancos";
import Seo from "../components/Seo";

export function Bancos() {
  const { t } = useTranslation();
  const pathByLang = t("seo.banks.pathByLang", { returnObjects: true });
  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
  }, []);

  return (
    <div>
      <Seo pageKey="banks" pathByLang={pathByLang} />
      <Navbar />
      <SeccionBancos />
    </div>
  );
}
